import React from 'react';
export const GridViewContext = React.createContext();